import React from "react";
import PropTypes from "prop-types";

import { StyledHeading } from "./styles";

const Heading = ({
    children,
    className,
    type,
    size,
    bottomSpacing,
    headingColor,
    alignment
}) => (
    <StyledHeading
        className={className}
        as={type}
        size={size}
        bottomSpacing={bottomSpacing}
        headingColor={headingColor}
        alignment={alignment}
    >
        {children}
    </StyledHeading>
);

Heading.propTypes = {
    type: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "span", "div"]),
    size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl"]),
    bottomSpacing: PropTypes.oneOf([
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        "2xl",
        "3xl",
        "4xl",
        "5xl"
    ]),
    alignment: PropTypes.oneOf(["left", "center", "right", "justify"]),
    headingColor: PropTypes.string
};

export default Heading;
